import type { Locale } from 'antd/es/locale'
import en_US from 'antd/locale/en_US'
import zh_CN from 'antd/locale/zh_CN'
import ar_EG from 'antd/locale/ar_EG'
import fr_FR from 'antd/locale/fr_FR'
import es_ES from 'antd/locale/es_ES'
import ru_RU from 'antd/locale/ru_RU'

interface AntdLocalMapType {
  [key: string]: Locale
}
/**
 * antd 语言local文件对应的 map
 */
export const ANTD_LOCALE_MAP: AntdLocalMapType = {
  en: en_US,
  zh: zh_CN,
  ar: ar_EG, // 阿拉伯文
  fr: fr_FR, // 法语
  ru: ru_RU, // 俄罗斯语
  es: es_ES, // 西班牙语
}
